export enum BrandCartEvents {
  GO_TO_BRAND_PAGE,
  OPEN_PRODUCT_MODAL,
  CHANGE_CART_QUANTITY,
  CHECKOUT,
  CHECKOUT_ERROR,
  GO_TO_BAG,
}

interface BrandCartEventHandlerPayload {
  event: BrandCartEvents;
  token?: string;
  quantities?: { oldValue: number; newValue: number };
  message?: string;
  brandToken?: string;
  retailerToken?: string;
}

export type BrandCartEventHandler = (
  payload: BrandCartEventHandlerPayload
) => void;
